import styled from 'styled-components';

import { theme, Tooltip } from '@/component-library';

const StyledTooltip = styled(Tooltip)`
  font-size: ${theme.text.xs};
`;

export { StyledTooltip };
